export const NO_SDC_ERROR = 1402;
export const NO_AUTH_ERROR = 1400;
export const UNKNOWN_ERROR = 1403;
export const TERRITORY_BLOCK_ERROR = 3600;
export const USER_NOT_REGISTERED = 2104;
